import styled from 'styled-components';

export const UserListWrapper = styled.div`
  max-height: 560px;
  overflow: hidden;
  padding-bottom: 20px;
`;

export const UserListContainer = styled.div``;
